/* eslint-disable @typescript-eslint/no-magic-numbers */
import { IsString, MaxLength } from "class-validator";

import "reflect-metadata";

export class EntityDto {
  id: number;

  @IsString()
  @MaxLength(255)
  name: string;
}
